<template>
	<div>
		<v-skeleton-loader width="100%" max-width="555" v-if="this.isLoading" type="card">
		</v-skeleton-loader>
		<div v-else class="mb-5 mt-3">
			<div v-for="attachment in this.forum.uploads" :key="attachment.upload_id" class="mt-1">
				<FileListComponent :attachment="attachment" :isDateView="false" />
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import FileListComponent from '@/components/FileListComponent.vue'

export default {
	name: 'ForumFile',
	components: { FileListComponent },
	methods: {
		...mapActions('forum', ['getForum']),
		...mapActions('app', ['setPageTitle']),
		getForumById() {
			this.getForum(this.$route.params.id)
		},
	},
	computed: {
		...mapGetters('forum', ['forum', 'isLoading']),
	},
	mounted() {
		this.setPageTitle('Attachments')
	},
	beforeDestroy() {
		this.setPageTitle('')
	},
	created() {
		if (this.$route.params.id !== undefined && (!this.isBlocked || this.isBlocked === null)) {
			this.getForumById()
		}
	},
}
</script>
<style></style>
